export default class PluggableElementBase {
    name;
    maybeDisplayName;
    constructor(args) {
        this.name = args?.name || 'UNKNOWN';
        this.maybeDisplayName = args?.displayName;
    }
    get displayName() {
        return this.maybeDisplayName || this.name;
    }
}
